import React from "react";
import BackImg from "@assets/images/stepsBack.jpg";
const EmptyPlanView = ({ IconComponent, heading, description }) => {
  return (
    <div
      className="rounded-[12px] h-full text-white bg-cover"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="p-10 h-full flex flex-col items-center justify-center">
        {/* Icon Container: White background, rounded, centered */}
        <div className="bg-white rounded-full flex justify-center items-center p-5 w-[fit-content]">
          {IconComponent}
        </div>

        {/* Heading */}
        <p className="mt-4 text-[20px] font-[600] font-[Lato] text-center">
          {heading}
        </p>

        {/* Description */}
        <p className="mt-2 text-[18px] font-[500] font-[Lato] text-center">
          {description}
        </p>
      </div>
    </div>
  );
};

export default EmptyPlanView;
